function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.454005 8.89027C0 9.8716 0 11.0001 0 13.2572V16.6283C0 19.6319 0 21.1338 0.898206 22.0669C1.79641 23 3.24205 23 6.13333 23H8.43333V14.2389C8.43333 13.799 8.77658 13.4424 9.2 13.4424H13.8C14.2234 13.4424 14.5667 13.799 14.5667 14.2389V23H16.8667C19.7579 23 21.2036 23 22.1018 22.0669C23 21.1338 23 19.6319 23 16.6283V13.2572C23 11.0001 23 9.8716 22.546 8.89027C22.092 7.90893 21.2437 7.20394 19.5472 5.79396L15.3315 2.29028C13.4943 0.763428 12.5757 0 11.5 0C10.4243 0 9.50569 0.763428 7.66854 2.29028L3.45281 5.79396C1.75628 7.20394 0.90801 7.90893 0.454005 8.89027Z",
  fill: "#6F62FF"
});

var SvgHomeSelected = function SvgHomeSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHomeSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeSelected.bfe24e76.svg";
export { ForwardRef as ReactComponent };